import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SUPPORT_URL } from '../mock';

const SupportCTA = () => (
  <section id="support" className="py-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="rounded-2xl border border-border bg-card px-8 py-16 text-center">
        <div className="section-label mb-4">Support</div>
        <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
          Prepare a <span className="gradient-text">certificate program</span> before activation.
        </h2>
        <p className="mt-5 text-lg text-muted-foreground max-w-2xl mx-auto">
          Open the Tangibl3Net support center for issuer compliance checks, documented-right intake, wallet settlement, .tangiblenet identity, evidence vault, beneficiary ledger, and controlled digital certificate questions.
        </p>
        <a href={SUPPORT_URL} className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-lg bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors">
          Prepare a Certificate Program <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  </section>
);

export default SupportCTA;
